export type PriceIntelRuntimeMode = 'local' | 'api';

const MODE_STORAGE_KEY = 'price_intel_runtime_mode';
const MODE_EVENT_NAME = 'price-intel-mode-change';

function getDefaultMode(): PriceIntelRuntimeMode {
  return import.meta.env.VITE_PRICE_INTEL_MODE === 'api' ? 'api' : 'local';
}

export function getPriceIntelRuntimeMode(): PriceIntelRuntimeMode {
  if (typeof window === 'undefined') {
    return getDefaultMode();
  }

  const stored = window.localStorage.getItem(MODE_STORAGE_KEY);
  return stored === 'api' || stored === 'local' ? stored : getDefaultMode();
}

export function setPriceIntelRuntimeMode(mode: PriceIntelRuntimeMode): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(MODE_STORAGE_KEY, mode);
  window.dispatchEvent(new CustomEvent<PriceIntelRuntimeMode>(MODE_EVENT_NAME, { detail: mode }));
}

export function subscribePriceIntelRuntimeMode(callback: (mode: PriceIntelRuntimeMode) => void): () => void {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  const handler = (event: Event) => {
    const nextMode = (event as CustomEvent<PriceIntelRuntimeMode>).detail;
    callback(nextMode);
  };

  window.addEventListener(MODE_EVENT_NAME, handler);
  return () => window.removeEventListener(MODE_EVENT_NAME, handler);
}

export function isLocalPriceIntelMode(): boolean {
  return getPriceIntelRuntimeMode() === 'local';
}

export function getPriceIntelRuntimeLabel(): string {
  return getPriceIntelRuntimeMode() === 'local' ? 'Local' : 'Online';
}
